import { Injectable } from '@angular/core';
import { DefaultHeaderTitleProviderService } from '../default-header-title-provider/default-header-title-provider.service';

export interface IHeaderTitle {
  unitName: string;
  unitStatus: string;
}

export interface IHeaderTitleProvider {
  setup();
  cleanup();
  getHeaderTitle(): IHeaderTitle;
}

@Injectable({
  providedIn: 'root'
})
export class HeaderTitleProviderService {
  private provider: IHeaderTitleProvider = null;

  constructor(private defaultHeaderTitleProvider: DefaultHeaderTitleProviderService) {}

  setup() {
    this.getProvider().setup();
  }

  private getProvider(): IHeaderTitleProvider {
    if (this.provider == null) {
      this.provider = this.defaultHeaderTitleProvider;
    }

    return this.provider;
  }

  cleanup() {
    this.getProvider().cleanup();
  }

  getHeaderTitle(): IHeaderTitle {
    return this.getProvider().getHeaderTitle();
  }

  setProvider(provider: IHeaderTitleProvider) {
    this.provider = provider;
  }
}
